import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';
import s from './PaymentHistory.module.scss';
import { useOutletContext } from 'react-router-dom';
import { Modal } from 'components/common/Modal/Modal';
import { useTranslation } from 'react-i18next';

export const PaymentHistory = () => {
  const { t } = useTranslation();
  const { goBack, closeRouteModal } =
    useOutletContext<ModalNavigationContext>();

  return (
    <Modal
      title={t('profile.pricesAndOperations.paymentHistory')}
      onBack={goBack}
      onClose={closeRouteModal}
    >
      <div className={s.container}></div>
    </Modal>
  );
};
